import React, { useState, useEffect, useRef, useCallback } from 'react';
import { MainComponent, Texts, Component1, Component2, InnerComponent, Component4, Component3, HiddenComponent, FooterPart, HeaderPart, SaveButton } from '../style.js';
import InputSelect from 'src/components/shared/Form/Select/index.js';
import { useTheme } from '@emotion/react';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import theme, { palette, shadows } from 'src/config/theme.js';
import { alpha, Box, Typography, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, ListItemAvatar, Avatar, Paper, ClickAwayListener, InputAdornment, IconButton } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DateTimePicker from 'src/components/App/DatePicker/index.js';
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { postAppointmentRequest, postPatientRequest, getPatientRequest, setCurrentClinics, getAppointmentRequest, getAvailableSlotsRequest, getCustomFieldsRequest, postMessageRequest, getPatientByIdRequest, getDoctorProfileByIdRequest, postBillingRequest, getAppointmentByPatientIdRequest, patientLookupRequest, postPatientInfoRequest, updatePatientByIdRequest, getClinicProfileByIdRequest } from '../../../store/appActions.js';
import { openWhatsApp } from 'src/utils/whatsapp';
import storage from 'src/utils/storageUtils.js';
import { jwtDecode } from 'jwt-decode';
import { reject } from 'lodash';
import ButtonComponent from 'src/components/shared/Button/index.js';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/images/add-square.svg';
import { getUserFromToken } from 'src/DecodeToken.js';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive.js';
import { useParams } from 'react-router-dom';
import { getActiveCase } from 'src/modules/app/api/appApi';

dayjs.extend(customParseFormat);

export function FetchSlotsEffect({ clinicId, token }) {

    const { values } = useFormikContext();
    console.log('[AddAppointment] clinicId from URL:', clinicId);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!values.date || !clinicId) return;

        const formattedDate = dayjs(values.date).format('YYYY-MM-DD');
        dispatch(getAvailableSlotsRequest(
            {
                token,
                params: {
                    clinicId,
                    date: formattedDate,
                },
            },
            null,
            (err) => {
                console.error('Failed to fetch available slots:', err);
            }
        ));
    }, [values.date, clinicId, token, dispatch]);

    return null;
}

const genderData = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Other', value: 'other' },
]

/** 
 * SENIOR BACKEND APPROACH: Master Data for Major Cities
 * This local cache ensures that common areas in major cities (e.g. Ahmedabad) 
 * are always available, even if the postal API's keyword search limits the
 * //
 */
const MAJOR_CITIES_LOCATIONS = {
    "ahmedabad": {
        state: "Gujarat",
        city: "Ahmedabad",
        district: "Ahmedabad",
        areas: [
            { name: "Satellite", pincode: "380015" },
            { name: "Bopal", pincode: "380058" },
            { name: "Bodakdev", pincode: "380054" },
            { name: "Prahlad Nagar", pincode: "380015" },
            { name: "Vastrapur", pincode: "380015" },
            { name: "Thaltej", pincode: "380054" },
            { name: "Gurukul", pincode: "380052" },
            { name: "Drive-in", pincode: "380054" },
            { name: "Navrangpura", pincode: "380009" },
            { name: "Naranpura", pincode: "380013" },
            { name: "Memnagar", pincode: "380052" },
            { name: "Paldi", pincode: "380007" },
            { name: "Maninagar", pincode: "380008" },
            { name: "Ghatlodia", pincode: "380061" },
            { name: "Chandkheda", pincode: "382424" },
            { name: "Motera", pincode: "380005" },
            { name: "Science City", pincode: "380060" },
            { name: "Shilaj", pincode: "380059" },
            { name: "Shela", pincode: "380058" },
            { name: "Gota", pincode: "382481" },
            { name: "C.G. Road", pincode: "380009" },
            { name: "Ashram Road", pincode: "380009" },
            { name: "Ellisbridge", pincode: "380006" },
            { name: "Usmanpura", pincode: "380013" },
            { name: "Ambawadi", pincode: "380006" },
            { name: "Nicol", pincode: "382350" },
            { name: "Naroda", pincode: "382330" },
            { name: "Isanpur", pincode: "382443" },
            { name: "Vasna", pincode: "380007" },
            { name: "Sola", pincode: "380060" },
            { name: "Shahibaug", pincode: "380004" },
            { name: "Vejalpur", pincode: "380051" },
            { name: "Juhapura", pincode: "380051" },
            { name: "Makarba", pincode: "380051" },
            { name: "Sarkhej", pincode: "380055" },
            { name: "South Bopal", pincode: "380058" },
            { name: "Gomtipur", pincode: "380021" },
            { name: "Odhav", pincode: "380022" },
            { name: "Amraiwadi", pincode: "380023" },
            { name: "Nikol", pincode: "382350" },
            { name: "New Ranip", pincode: "382480" },
            { name: "Ranip", pincode: "382480" },
            { name: "Sabarmati", pincode: "380005" },
            { name: "Ghodasar", pincode: "380050" },
            { name: "Narol", pincode: "382440" },
            { name: "Vatva", pincode: "382440" },
            { name: "Jodhpur", pincode: "380015" },
            { name: "Nehrunagar", pincode: "380015" },
            { name: "Ambli", pincode: "380058" },
            { name: "Sanand", pincode: "382110" },
            { name: "Kathwada", pincode: "382430" },
            { name: "Bapunagar", pincode: "380024" },
            { name: "Indiapura", pincode: "380024" },
            { name: "Meghaninagar", pincode: "380016" },
            { name: "Kankaria", pincode: "380022" },
            { name: "Dani Limda", pincode: "380028" },
            { name: "Shah-e-Alam", pincode: "380028" },
            { name: "Behrampura", pincode: "380022" },
            { name: "Khanpur", pincode: "380001" },
            { name: "Khadia", pincode: "380001" },
            { name: "Kalupur", pincode: "380001" },
            { name: "Dariapur", pincode: "380001" }
        ]
    },

    "surat": {
        state: "Gujarat",
        city: "Surat",
        district: "Surat",
        areas: [
            { name: "Adajan", pincode: "395009" },
            { name: "Vesu", pincode: "395007" },
            { name: "Piplod", pincode: "395007" },
            { name: "Varachha", pincode: "395006" },
            { name: "Katargam", pincode: "395004" },
            { name: "City Light", pincode: "395007" },
            { name: "Nanpura", pincode: "395001" },
            { name: "Rander", pincode: "395005" },
            { name: "Athwa Lines", pincode: "395007" },
            { name: "Udhana", pincode: "394210" }
        ]
    }
}
const validationSchema = Yup.object().shape({
    firstName: Yup.string().when('patient', {
        is: 'New Patient',
        then: (schema) => schema.required('First Name is required'),
    }),
    lastName: Yup.string().when('patient', {
        is: 'New Patient',
        then: (schema) => schema.required('Last Name is required'),
    }),
    contactNo: Yup.string().when('patient', {
        is: 'New Patient',
        then: (schema) => schema.required('Enter Phone Number').matches(/^\d{10}$/, 'Contact number must be exactly 10 digits'),
    }).nullable(),

    dateOfBirth: Yup.date().nullable().when('patient', {
        is: 'New Patient',
        then: (schema) => schema.required('Select Your Date of Birth'),
    }),

    gender: Yup.string().when('patient', {
        is: 'New Patient',
        then: (schema) => schema.required('Select Your gender'),
    }),

    date: Yup.date().required('Select Appointment Date'),
    time: Yup.string().required('Select Appointment Time'),
    addnotes: Yup.string().required('Enter Symptoms'),
    consultingFees: Yup.number().min(0, 'Fees must be 0 or more').required('Consulting Fees is required'),
});

const FeeManager = ({ consultingData, setConsultingFees, isProfilesLoaded, doctorId, clinicId, activeCase, setActiveCase }) => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        const checkCaseAndSetFees = async () => {
            if (values.patient === 'New Patient' || values.patient === '') {
                const fee = consultingData.newCaseConsultingFees || 0;
                setConsultingFees(fee);
                setFieldValue('consultingFees', fee);
                setActiveCase(null);
                return;
            }

            if (isProfilesLoaded && consultingData && Object.keys(consultingData).length > 0 && doctorId && clinicId) {
                try {
                    const response = await getActiveCase({ patient: values.patient, doctor: doctorId, clinic: clinicId });
                    if (response && response.activeCase) {
                        setActiveCase(response.activeCase);
                        const fee = consultingData.oldCaseConsultingFees || 0;
                        setConsultingFees(fee);
                        setFieldValue('consultingFees', fee);
                    } else {
                        setActiveCase(null);
                        const fee = consultingData.newCaseConsultingFees || 0;
                        setConsultingFees(fee);
                        setFieldValue('consultingFees', fee);
                    }
                } catch (error) {
                    console.error("Error checking active case:", error);
                    // fallback to new case fee
                    const fee = consultingData.newCaseConsultingFees || 0;
                    setConsultingFees(fee);
                    setFieldValue('consultingFees', fee);
                    setActiveCase(null);
                }
            }
        };
        checkCaseAndSetFees();
    }, [values.patient, consultingData, isProfilesLoaded, doctorId, clinicId, setFieldValue, setConsultingFees, setActiveCase]);

    return null;
};




const PatientSearch = ({ setLastVisitDays, setConsultingFees, doctorProfile, customFields }) => {
    const { values, setFieldValue, setValues } = useFormikContext();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [searchPhone, setSearchPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchMessage, setSearchMessage] = useState('');
    const [multiplePatients, setMultiplePatients] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const extractPatientsFromResponse = (response) => {
        let rawPatients = [];

        if (!response) return [];

        // 1. Handle direct array response
        if (Array.isArray(response)) {
            rawPatients = response;
        }
        // 2. Handle common nested patterns from different API wrappers
        else if (response?.patients && Array.isArray(response.patients)) {
            rawPatients = response.patients;
        } else if (response?.data?.patients && Array.isArray(response.data.patients)) {
            rawPatients = response.data.patients;
        } else if (response?.payload?.patients && Array.isArray(response.payload.patients)) {
            rawPatients = response.payload.patients;
        } else if (response?.result?.patients && Array.isArray(response.result.patients)) {
            rawPatients = response.result.patients;
        }

        // 3. Handle single object response wrapped in common keys
        if (rawPatients.length === 0) {
            const potentialPatient = response?.patient || response?.data?.patient || response?.payload?.patient || response?.result?.patient;
            if (potentialPatient) {
                rawPatients = [potentialPatient];
            } else if (response?.id || response?._id || response?.fullName || response?.contactNo) {
                // The response might be the patient object itself
                rawPatients = [response];
            }
        }

        // 4. Deduplicate by ID and ensure basic structure
        const seen = new Set();
        return rawPatients.filter((p) => {
            if (!p || typeof p !== 'object') return false;

            // Extract a unique identifier
            const rawId = p.id || p._id || p.patientId;
            const key = rawId ? rawId.toString() : JSON.stringify(p);

            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    };

    const getNameParts = (data) => {
        if (data.firstName || data.middleName || data.lastName) {
            return {
                firstName: data.firstName || '',
                middleName: data.middleName || '',
                lastName: data.lastName || '',
            };
        }

        const names = (data.fullName || '').trim().split(/\s+/).filter(Boolean);
        return {
            firstName: names[0] || '',
            middleName: names.length > 2 ? names[1] : '',
            lastName: names.length > 2 ? names.slice(2).join(' ') : (names[1] || ''),
        };
    };

    const populatePatientData = async (patient) => {
        const fetchId = patient.id || patient._id || patient.patientId;
        setLoading(true);

        try {
            const patientDetails = await new Promise((resolve, reject) => {
                dispatch(getPatientByIdRequest(fetchId, resolve, reject));
            });

            const data = patientDetails?.patient || patient;
            const { firstName, middleName, lastName } = getNameParts(data);

            const nextValues = {
                ...values,
                patient: data.id || data._id || patient.id || patient._id || patient.patientId || '',
                patientId: data.patientId || patient.patientId || '',
                firstName,
                middleName,
                lastName,
                contactNo: data.contactNo || patient.contactNo || searchPhone,
                gender: data.gender || patient.gender || '',
                dateOfBirth: data.dateOfBirth
                    ? dayjs(data.dateOfBirth).format('YYYY-MM-DD')
                    : (data.dob ? dayjs(data.dob).format('YYYY-MM-DD') : null),
                pincode: data.pincode || data.customData?.pincode || '',
                city: data.city || data.customData?.city || '',
                state: data.state || data.customData?.state || '',
                area: data.area || data.customData?.area || '',
                postalAddress: data.postalAddress || data.customData?.postalAddress || '',
            };

            customFields.forEach((field) => {
                const fieldValue =
                    data?.[field.fieldName] ??
                    data?.customData?.[field.fieldName] ??
                    '';

                if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                    nextValues[field.fieldName] = fieldValue;
                }
            });

            setValues(nextValues);

            if (data.lastVisitDays !== undefined && data.lastVisitDays !== null) {
                console.log('Setting last visit days from data:', data.lastVisitDays);
                setLastVisitDays(data.lastVisitDays);
            } else if (data.lastVisitDays === 0) {
                setLastVisitDays(0);
            } else {
                const appointments = await new Promise((resolve, reject) => {
                    dispatch(getAppointmentByPatientIdRequest({ patientId: fetchId }, resolve, reject));
                });

                if (appointments && appointments.data && Array.isArray(appointments.data) && appointments.data.length > 0) {
                    const pastAppointments = appointments.data
                        .map(appt => dayjs(appt.date))
                        .filter(date => date.isValid() && (date.isBefore(dayjs().startOf('day')) || date.isSame(dayjs().startOf('day'))))
                        .sort((a, b) => b.diff(a));

                    if (pastAppointments.length > 0) {
                        const lastVisit = pastAppointments[0];
                        const daysDiff = dayjs().startOf('day').diff(lastVisit.startOf('day'), 'day');
                        setLastVisitDays(daysDiff);
                    } else {
                        setLastVisitDays(null);
                    }
                } else {
                    setLastVisitDays(null);
                }
            }
        } catch (error) {
            console.error('Failed to populate patient data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async (phone) => {
        if (!phone || phone.length < 10) return;

        setLoading(true);
        setSearchMessage('');
        setMultiplePatients([]);
        setShowDropdown(false);

        try {
            let response = await new Promise((resolve, reject) => {
                dispatch(patientLookupRequest(phone, resolve, reject));
            });

            if (typeof response === 'string') {
                try { response = JSON.parse(response); } catch (e) { }
            }
            if (response && response.data && typeof response.found === 'undefined') {
                response = response.data;
            }

            console.log('[PatientSearch] lookup response:', response);

            const allMatches = extractPatientsFromResponse(response);
            console.log('[PatientSearch] matches prepared for dropdown:', allMatches);

            // Robust fallback if extraction failed but API indicated success
            let finalMatches = allMatches;
            if (finalMatches.length === 0 && response?.found === true) {
                // If found is true but list empty, try to pluck patient from any possible property
                const fallback = response.patient || response.data?.patient || response.data;
                if (fallback && (fallback.id || fallback._id || fallback.fullName || fallback.contactNo)) {
                    finalMatches = Array.isArray(fallback) ? fallback : [fallback];
                }
            }

            if (response?.found === true || finalMatches.length > 0) {
                if (finalMatches.length > 0) {
                    setMultiplePatients(finalMatches);
                    setShowDropdown(true);
                    setSearchMessage('Patient Found');

                    if (finalMatches.length === 1) {
                        await populatePatientData(finalMatches[0]);
                    }
                } else {
                    setSearchMessage('Add New Patient');
                    setValues({
                        ...values,
                        patient: 'New Patient',
                        contactNo: phone,
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        gender: '',
                        dateOfBirth: null,
                        patientId: '',
                    });
                    setLastVisitDays(null);
                }
            } else {
                setSearchMessage('Add New Patient');
                setValues({
                    ...values,
                    patient: 'New Patient',
                    contactNo: phone,
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    gender: '',
                    dateOfBirth: null,
                    patientId: '',
                    pincode: '',
                    city: '',
                    state: '',
                    area: '',
                    postalAddress: '',
                });
                setLastVisitDays(null);
            }
        } catch (error) {
            console.error('Lookup failed:', error);
            setSearchMessage('Add New Patient');
            setValues({
                ...values,
                patient: 'New Patient',
                contactNo: phone,
                firstName: '',
                middleName: '',
                lastName: '',
                gender: '',
                dateOfBirth: null,
                patientId: '',
                pincode: '',
                city: '',
                state: '',
                area: '',
                postalAddress: '',
            });
            setLastVisitDays(null);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
            <Box sx={{ width: '100%' }}>
                <Component1>
                    <Texts>Search Patient (Phone)</Texts>
                    <Box sx={{ position: 'relative' }}>
                        <InputComponent
                            name="searchPhone"
                            placeholder="Enter phone number"
                            value={searchPhone}
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                setSearchPhone(val);
                                if (val.length === 10) {
                                    handleSearch(val);
                                } else {
                                    setValues({
                                        ...values,
                                        patient: '',
                                        patientId: 'Auto-generated',
                                        firstName: '',
                                        middleName: '',
                                        lastName: '',
                                        contactNo: '',
                                        gender: '',
                                        dateOfBirth: null,
                                        pincode: '',
                                        city: '',
                                        state: '',
                                        area: '',
                                        postalAddress: '',
                                    });
                                    setLastVisitDays(null);
                                    setSearchMessage('');
                                    setShowDropdown(false);
                                    setMultiplePatients([]);
                                }
                            }}
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setShowDropdown(!showDropdown)}
                                            disabled={multiplePatients.length === 0}
                                            sx={{ p: 0.5 }}
                                        >
                                            <KeyboardArrowDownIcon sx={{ color: alpha(palette.gery.black, 0.4), transform: showDropdown ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                backgroundColor: palette.gery.white,
                                boxShadow: shadows[1],
                                '& .MuiOutlinedInput-root': {
                                    height: '52px',
                                    borderRadius: '12px',
                                },
                            }}
                        />
                        {loading && (
                            <Typography variant="caption" sx={{ position: 'absolute', bottom: -20, left: 0, color: theme.palette.primary.main }}>
                                Searching...
                            </Typography>
                        )}
                        {searchMessage && (
                            <Typography variant="caption" sx={{ position: 'absolute', bottom: -20, left: 0, color: searchMessage.includes('Add') ? theme.palette.success.main : theme.palette.primary.main, fontWeight: 600 }}>
                                {searchMessage}
                            </Typography>
                        )}

                        {showDropdown && multiplePatients.length > 0 && (
                            <Paper
                                sx={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    zIndex: 1500,
                                    mt: 0.5,
                                    borderRadius: '12px',
                                    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff',
                                    border: `1px solid ${alpha(palette.gery.black, 0.08)}`,
                                }}
                            >
                                <List sx={{ py: 0, maxHeight: '300px', overflowY: 'auto' }}>
                                    <ListItem
                                        button
                                        onClick={() => {
                                            setValues({
                                                ...values,
                                                patient: 'New Patient',
                                                contactNo: searchPhone,
                                                firstName: '',
                                                middleName: '',
                                                lastName: '',
                                                gender: '',
                                                dateOfBirth: null,
                                                patientId: '',
                                                pincode: '',
                                                city: '',
                                                state: '',
                                                area: '',
                                                postalAddress: '',
                                            });
                                            setLastVisitDays(null);
                                            setShowDropdown(false);
                                            setSearchMessage('Add New Patient');
                                        }}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                                            backgroundColor: alpha(theme.palette.primary.main, 0.05),
                                            '&:hover': {
                                                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                            },
                                        }}
                                    >
                                        <ListItemAvatar sx={{ minWidth: '48px' }}>
                                            <Avatar
                                                sx={{
                                                    width: 36,
                                                    height: 36,
                                                    bgcolor: theme.palette.primary.main,
                                                    color: '#fff'
                                                }}
                                            >
                                                <AddIcon style={{ width: '20px', height: '20px' }} />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary="Add New Patient"
                                            primaryTypographyProps={{
                                                fontWeight: 700,
                                                fontSize: '15px',
                                                color: theme.palette.primary.main
                                            }}
                                            secondary="Create a new record for this number"
                                            secondaryTypographyProps={{
                                                fontSize: '12px'
                                            }}
                                        />
                                    </ListItem>

                                    {multiplePatients.map((patient, index) => (
                                        <ListItem
                                            button
                                            key={patient.id || patient._id || patient.patientId || index}
                                            onClick={() => {
                                                populatePatientData(patient);
                                                setShowDropdown(false);
                                                setSearchMessage('Patient Found');
                                            }}
                                            sx={{
                                                py: 1.5,
                                                px: 2,
                                                borderBottom: index < multiplePatients.length - 1 ? `1px solid ${alpha(palette.gery.black, 0.04)}` : 'none',
                                                '&:hover': {
                                                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                                                },
                                            }}
                                        >
                                            <ListItemText
                                                primary={patient.fullName || `${patient.firstName || ''} ${patient.lastName || ''}`.trim() || 'Unknown Patient'}
                                                secondary={`${patient.gender || 'N/A'} | ${patient.detailedAge?.ageString || (patient.age ? `${patient.age} Years` : 'N/A')} | ${patient.patientId || patient.id || patient._id || 'No ID'}`}
                                                primaryTypographyProps={{
                                                    fontWeight: 600,
                                                    fontSize: '15px',
                                                    color: palette.gery.black,
                                                    mb: 0.2
                                                }}
                                                secondaryTypographyProps={{
                                                    fontSize: '12px',
                                                    color: alpha(palette.gery.black, 0.6)
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        )}
                    </Box>
                </Component1>
            </Box>
        </ClickAwayListener>
    );
};

// Global cache for pincode data from GitHub to prevent repeated downloads
let cachedPincodeData = null;
const fetchGithubPincodes = async () => {
    if (cachedPincodeData) return cachedPincodeData;
    try {
        const response = await fetch('https://raw.githubusercontent.com/mithunsasidharan/India-Pincode-Lookup/master/pincodes.json');
        cachedPincodeData = await response.json();
        return cachedPincodeData;
    } catch (err) {
        console.error('Failed to fetch pincode json:', err);
        return [];
    }
};

// PincodeLookup: Defined outside AddAppointment to maintain stable component identity across re-renders
const PincodeLookup = ({ customFields, setFieldValue, setFilteredAreas, setFilteredPincodes, setLookupSource }) => {
    const { values } = useFormikContext();
    const pincode = values.pincode;

    useEffect(() => {
        if (pincode && pincode.length === 6) {
            const fetchPincodeData = async () => {
                try {
                    let postOffices = [];

                    // Try fetching from GitHub raw JSON first as it's reliable
                    try {
                        const allPincodes = await fetchGithubPincodes();
                        const matched = allPincodes.filter(p => p.pincode.toString() === pincode.toString());
                        if (matched && matched.length > 0) {
                            postOffices = matched.map(m => ({
                                Name: m.officeName.replace(/ B\.O$| S\.O$| H\.O$/, ''),
                                District: m.districtName,
                                State: m.stateName,
                                Pincode: m.pincode.toString()
                            }));
                        }
                    } catch (e) {
                        console.error('Github JSON failed, fallback to API', e);
                    }

                    // Fallback to postalpincode API if github json is not available or returned no results
                    if (postOffices.length === 0) {
                        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
                        const data = await response.json();
                        if (data && data[0].Status === "Success") {
                            postOffices = data[0].PostOffice;
                        }
                    }

                    if (postOffices && postOffices.length > 0) {
                        const firstPO = postOffices[0];
                        const city = firstPO.District;
                        const state = firstPO.State;

                        setFieldValue('city', city);
                        setFieldValue('state', state);
                        setLookupSource('pincode');

                        customFields.forEach(field => {
                            const label = field.label.toLowerCase();
                            if (label.includes('city')) setFieldValue(field.fieldName, city);
                            if (label.includes('state')) setFieldValue(field.fieldName, state);
                            if (label.includes('area')) setFieldValue(field.fieldName, firstPO.Name);
                        });

                        const areaOptions = postOffices.map(po => ({
                            label: po.District ? `${po.Name} (${po.District}) (${po.Pincode})` : `${po.Name} (${po.Pincode})`,
                            value: po.Name,
                            pincode: po.Pincode,
                            district: po.District,
                            state: po.State
                        }));
                        setFilteredAreas(areaOptions);
                        setFilteredPincodes([]);
                        if (areaOptions.length > 0) {
                            const first = areaOptions[0];
                            setFieldValue('area', first.value);
                            if (first.district) setFieldValue('city', first.district);
                            if (first.state) setFieldValue('state', first.state);
                        }
                    }
                } catch (error) {
                    console.error("Pincode fetch failed:", error);
                }
            };
            fetchPincodeData();
        } else if (!pincode || pincode.length < 6) {
            setFilteredAreas([]);
        }
    }, [pincode, customFields, setFieldValue, setFilteredAreas, setFilteredPincodes, setLookupSource]);

    return null;
};

// UniversalLocationSearch: Handles reverse lookups for City and Area names
// This component provides a professional CRM flow where typing a Locality/Area (e.g., "Adajan")
// will automatically find and fill the Pincode, City, and State.
const UniversalLocationSearch = ({ customFields, setFieldValue, setFilteredAreas, setFilteredPincodes, setLookupSource, lookupSource }) => {
    const { values } = useFormikContext();
    const cityField = customFields.find(f => f.label.toLowerCase().includes('city'));
    const areaField = customFields.find(f => f.label.toLowerCase().includes('area'));

    const city = values.city || (cityField ? values[cityField.fieldName] : '');
    const area = values.area || (areaField ? values[areaField.fieldName] : '');

    const timerRef = useRef(null);
    const lastSearchRef = useRef("");

    useEffect(() => {
        // Don't trigger if this search was the RESULT of a previous lookup (pincode or selection)
        if (lookupSource === 'pincode' || lookupSource === 'selection') return;

        if (timerRef.current) clearTimeout(timerRef.current);

        // We look for the most specific string typed (Area preferred over City for search)
        const searchStr = (area && area.length >= 3) ? area : (city && city.length >= 3) ? city : "";

        if (!searchStr || searchStr.trim().length < 3) {
            if (lastSearchRef.current !== "") {
                setFilteredAreas([]);
                setFilteredPincodes([]);
                lastSearchRef.current = "";
            }
            return;
        }

        if (searchStr && searchStr.trim().length >= 3 && searchStr !== lastSearchRef.current) {
            console.log(`[LocationSearch] Debounce started for: "${searchStr}"`);
            timerRef.current = setTimeout(async () => {
                try {
                    const query = searchStr.trim().toLowerCase();
                    lastSearchRef.current = query;

                    // 1. LOCAL CACHE MATCH (Priority for speed & Reliability)
                    const foundMajorCityKey = Object.keys(MAJOR_CITIES_LOCATIONS).find(key => query.includes(key) || key.includes(query));
                    if (foundMajorCityKey) {
                        const cityData = MAJOR_CITIES_LOCATIONS[foundMajorCityKey];
                        console.log(`[LocationSearch] 🚀 Match found in local Master Data for: ${foundMajorCityKey}`);

                        setFieldValue('state', cityData.state);
                        setFieldValue('city', cityData.city);

                        const areaOptions = cityData.areas.map(a => ({
                            label: `${a.name} (${cityData.city}) (${a.pincode})`,
                            value: a.name,
                            pincode: a.pincode,
                            city: cityData.city,
                            state: cityData.state
                        }));

                        setFilteredAreas(areaOptions);
                        setFilteredPincodes([...new Set(cityData.areas.map(a => a.pincode))].map(p => ({ label: p, value: p, city: cityData.city, state: cityData.state })));
                        return; // Stop here if we have local results
                    }

                    // 2. BACKEND API SEARCH (Fallback for other areas)
                    console.log(`[LocationSearch] Fetching results from Backend for: "${query}"`);

                    try {
                        /** 
                         * SENIOR SECURITY FIX: 
                         * Using process.env.REACT_APP_BASE_API_URL ensures we don't hit localhost on live.
                         * This prevents the "Access other apps and services" browser popup which is 
                         * triggered by Private Network Access or Mixed Content attempts to localhost.
                         */
                        const rawBase = process.env.REACT_APP_BASE_API_URL || "";
                        const cleanBase = rawBase.replace(/['"]+/g, '').replace(/\/$/, '');
                        const baseUrl = cleanBase || (window.location.hostname === 'localhost' ? 'http://localhost:1337' : window.location.origin);

                        const response = await fetch(`${baseUrl}/location/search?query=${encodeURIComponent(query)}`);

                        if (!response.ok) {
                            console.warn(`[LocationSearch] API failed with status: ${response.status}. Fallback to empty.`);
                            return;
                        }

                        const locations = await response.json();

                        if (locations && Array.isArray(locations) && locations.length > 0) {
                            console.log(`[LocationSearch] ✅ Success: Found ${locations.length} locations for "${query}"`);

                            // Clear old results
                            setFilteredAreas([]);
                            setFilteredPincodes([]);

                            const first = locations[0];
                            setFieldValue('state', first.state);
                            if (locations.every(l => l.city === first.city) || locations.some(l => l.city.toLowerCase() === query.toLowerCase())) {
                                const bestCity = locations.find(l => l.city.toLowerCase() === query.toLowerCase())?.city || first.city;
                                setFieldValue('city', bestCity);
                                if (cityField) setFieldValue(cityField.fieldName, bestCity);
                            }

                            customFields.forEach(field => {
                                if (field.label.toLowerCase().includes('state')) setFieldValue(field.fieldName, first.state);
                            });

                            const areaOptions = locations.map(loc => ({
                                label: (loc.city && loc.city.toLowerCase() !== query.toLowerCase()) ? `${loc.area} (${loc.city}) (${loc.pincode})` : `${loc.area} (${loc.pincode})`,
                                value: loc.area,
                                pincode: loc.pincode,
                                city: loc.city,
                                state: loc.state
                            }));
                            setFilteredAreas(areaOptions);

                            const uniquePincodes = [...new Set(locations.map(l => l.pincode))];
                            setFilteredPincodes(uniquePincodes.map(pc => {
                                const l = locations.find(loc => loc.pincode === pc);
                                return { label: pc, value: pc, city: l?.city, state: l?.state };
                            }));
                        }
                    } catch (e) {
                        console.error("[LocationSearch] ❌ Backend API Error:", e);
                    }
                } catch (error) {
                    console.error("[LocationSearch] ❌ Debounce Error:", error);
                }
            }, 600);
        }

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [city, area, lookupSource, customFields, setFieldValue, setFilteredAreas, setFilteredPincodes, setLookupSource]);

    return null;
};

function AddAppointment({ onClose, updateAppointments }) {
    const { isMobile, isTablet } = useResponsive();
    const theme = useTheme();
    const { clinicId: urlClinicId, doctorId: urlDoctorId } = useParams();
    const [dob, setDob] = useState(null);
    const [patients, setPatients] = useState([]);
    const [lastVisitDays, setLastVisitDays] = useState(null);
    const [activeCase, setActiveCase] = useState(null);
    const [customFields, setCustomFields] = useState([]);
    const [clinicProfile, setClinicProfile] = useState(null);
    const [doctorProfile, setDoctorProfile] = useState(null);
    const [consultingFees, setConsultingFees] = useState(0);
    const [filteredAreas, setFilteredAreas] = useState([]);
    const [filteredPincodes, setFilteredPincodes] = useState([]);
    const [lookupSource, setLookupSource] = useState(null);
    const clinicData = useSelector((state) => state.app.clinics);
    console.log('my fav clinic', clinicData)
    const dispatch = useDispatch();
    const token = storage.get('TOKEN');
    const clinicId = clinicData?.clinicId || urlClinicId;
    const availableSlots = useSelector(state => state.app.availableSlots || []);
    console.log("Available Slots:", availableSlots);

    const doctorTimings = doctorProfile?.data?.doctorTimings || doctorProfile?.doctorTimings || doctorProfile?.timings || (doctorProfile?.data && { timings: doctorProfile.data.timings }) || doctorProfile || {};
    const doctorConsulting = (doctorProfile?.data?.consulting || doctorProfile?.consulting || doctorProfile?.payload?.data?.consulting || doctorProfile) || {};

    const isDoctorLoaded = !!(doctorProfile);
    const isClinicLoaded = clinicId ? !!(clinicProfile) : true;
    const isProfilesLoaded = isDoctorLoaded && isClinicLoaded;

    const clinicHasSettings = clinicProfile?.clinicSetting && Object.keys(clinicProfile.clinicSetting).filter(k => k !== 'clinic').length > 0;
    const isAcceptingTokens = clinicProfile?.clinicSetting?.acceptingTokens === 'yes';

    const associatedDoctors = clinicProfile?.clinicSetting?.associatedDoctors || [];
    const isSingleDoctor = associatedDoctors.length <= 1;

    const consultingData = (isProfilesLoaded && clinicHasSettings)
        ? {
            newCaseConsultingFees: clinicProfile.clinicSetting.consultingFees > 0 ? clinicProfile.clinicSetting.consultingFees : (doctorConsulting.newCaseConsultingFees || 0),
            oldCaseConsultingFees: clinicProfile.clinicSetting.oldCaseConsultingFees > 0 ? clinicProfile.clinicSetting.oldCaseConsultingFees : (doctorConsulting.oldCaseConsultingFees || 0),
            consultationValidityDays: clinicProfile.clinicSetting.caseValidityDays || doctorConsulting.consultationValidityDays || 90,
            gapBetweenAppointments: isSingleDoctor
                ? (clinicProfile.clinicSetting.gapBetweenAppointments || 15)
                : (doctorConsulting.gapBetweenAppointments || 15)
        }
        : doctorConsulting;

    let gap = Number(consultingData.gapBetweenAppointments || 15);
    if (gap <= 0) gap = 15;

    if (gap === 0 && doctorProfile?.gapBetweenAppointments) {
        gap = Number(doctorProfile.gapBetweenAppointments);
    }
    if (gap === 0 && doctorProfile?.data?.gapBetweenAppointments) {
        gap = Number(doctorProfile.data.gapBetweenAppointments);
    }

    console.log('Doctor Profile Data:', doctorProfile);
    console.log('Consulting Data:', consultingData);
    console.log('Calculated Gap:', gap);

    useEffect(() => {
        const userId = urlDoctorId || getUserFromToken();
        if (userId) {
            dispatch(getDoctorProfileByIdRequest(userId, (res) => {
                console.log('Fetched Doctor Profile:', res);
                setDoctorProfile(res);
            }));
        }
    }, [dispatch]);

    useEffect(() => {
        if (clinicId) {
            dispatch(getClinicProfileByIdRequest(clinicId, (res) => {
                console.log('Fetched Clinic Profile:', res);
                setClinicProfile(res?.profile || res);
            }));
        }
    }, [clinicId, dispatch]);

    useEffect(() => {
        if (clinicId) {
            dispatch(getCustomFieldsRequest(clinicId, (res) => {
                setCustomFields(res?.fields || []);
            }));
        }
    }, [clinicId, dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await new Promise((resolve, reject) =>
                dispatch(getPatientRequest({ token }, resolve, reject))
            );

            console.log('Fetched Patients:', response);

            if (response && response.data?.length) {
                setPatients(
                    response.data.map((patient) => {
                        return {
                            label: `${patient.fullName} (${patient.patientId || 'No ID'})`,
                            value: patient.id,
                            detailedAge: patient.detailedAge,
                            gender: patient.gender,
                            ...patient
                        };
                    })
                );
            }
        };

        fetchData();
    }, [dispatch, token]);


    const modifiedPatients = [
        {
            label: 'New Patient', value: 'New Patient', customStyle: {
                color: `${theme.palette.primary.main} !important`,
                '&:hover': {
                    backgroundColor: 'transparent !important',
                },
            }

        },
        ...patients,
    ];


    const handleSubmit = async (values, { resetForm }) => {
        console.log('Form Submitted with values:', values);
        const userId = urlDoctorId || getUserFromToken();
        console.log("my user id here", userId)
        if (!userId) {
            toast.error('Failed to identify user. Please login again.');
            return;
        }

        try {
            let patientId = values.patient;
            if (values.patient === 'New Patient') {
                const fullName = [values.firstName, values.middleName, values.lastName].filter(Boolean).join(' ');
                const patientData = {
                    fullName: fullName,
                    firstName: values.firstName,
                    middleName: values.middleName,
                    lastName: values.lastName,
                    contactNo: values.contactNo,
                    waNo: values.waNo || values.contactNo,
                    gender: values.gender,
                    dateOfBirth: dayjs(values.dateOfBirth).format('YYYY-MM-DD'),
                    users: [userId],
                    clinic: clinicData?.clinicId,
                    pincode: values.pincode,
                    area: values.area,
                    city: values.city,
                    state: values.state,
                    postalAddress: values.postalAddress,
                    ...customFields.reduce((acc, field) => {
                        if (values[field.fieldName]) {
                            acc[field.fieldName] = values[field.fieldName];
                        }
                        return acc;
                    }, {}),
                };

                const createdPatient = await new Promise((resolve, reject) => {
                    dispatch(postPatientRequest({ data: patientData, resolve, reject }));
                });

                patientId = createdPatient?.patient?.id;

                if (!patientId) {
                    console.log('Failed to create patient. Please try again.', { variant: 'error' });
                    return;
                }

                console.log('Patient added successfully', { variant: 'success' });
                console.log('🟢 NEW PATIENT CREATED - ID:', patientId);
            }

            const appointmentData = {
                date: values.date,
                time: values.time,
                addnotes: values.addnotes,
                scheduleType: values.scheduleType,
                recordStatus: values.scheduleType === 'token' ? 'In Queue' : 'Scheduled',
                user: userId,
                patient: patientId,
                clinic: clinicData?.clinicId,
            };

            console.log('my appointment data', appointmentData)

            const response = await new Promise((resolve, reject) => {
                dispatch(postAppointmentRequest({ data: appointmentData, resolve, reject }));
            });
            toast.success(response.message);

            try {
                const confirmationText = `Your appointment is scheduled on ${dayjs(values.date).format('DD-MM-YYYY')} at ${values.time}.`;

                let phone = '';
                phone = values.contactNo;

                if (phone) {
                    const msgPayload = {
                        language: 'english',
                        title: 'Appointment Confirmation',
                        message: confirmationText,
                        clinic: clinicData?.clinicId,
                        patient: patientId,
                    };
                    dispatch(postMessageRequest(msgPayload, () => { }, () => { }));

                    console.log('Appointment booked. Automatic WhatsApp message will be sent by backend. Phone:', phone);
                    // openWhatsApp(phone, confirmationText);
                }
            } catch (err) {
                console.error('WhatsApp redirection error:', err);
            }


            updateAppointments();

            const tokenApptId = response?.tokenappointment?.id || response?.appointment?.id;
            const feesAmount = Number(values.consultingFees || 0);

            if (tokenApptId && feesAmount > 0) {
                const debitPayload = {
                    paymentFor: 'consultation',
                    amount: feesAmount,
                    date: dayjs().format('YYYY-MM-DD'),
                    type: 'debit',
                    method: 'cash',
                    clinic: clinicData?.clinicId,
                    patient: patientId,
                    user: userId,
                    tokenAppointment: tokenApptId,
                };

                const creditPayload = {
                    ...debitPayload,
                    type: 'credit',
                };

                try {
                    // Sequential billing: takeLatest in saga cancels the first request
                    // when two same-type actions are dispatched simultaneously via Promise.all
                    await new Promise((resolve, reject) => {
                        dispatch(postBillingRequest(debitPayload, resolve, reject));
                    });
                    await new Promise((resolve, reject) => {
                        dispatch(postBillingRequest(creditPayload, resolve, reject));
                    });
                    console.log('Consultation billing created successfully');
                    window.dispatchEvent(new CustomEvent('app:billingCreated'));
                } catch (err) {
                    console.error('Failed to create billing entries:', err);
                }
            }

            const vitalsData = {
                weight: values.weight,
                height: values.height,
                pulseRate: values.pulseRate,
                spo2: values.spo2,
                respiratoryRate: values.respiratoryRate,
                temperature: values.temperature,
                patient: patientId,
                user: userId,
                clinic: clinicData?.clinicId || urlClinicId,
            };

            const vitalFields = [values.weight, values.height, values.pulseRate, values.spo2, values.respiratoryRate, values.temperature];
            const hasVitals = vitalFields.some(v => v !== undefined && v !== null && v !== '');

            console.log('🔵 VITALS CHECK - hasVitals:', hasVitals, 'vitalFields:', vitalFields);
            console.log('🔵 VITALS DATA:', vitalsData);

            if (hasVitals) {
                try {
                    const vitalsResponse = await new Promise((resolve, reject) => {
                        dispatch(postPatientInfoRequest(vitalsData, resolve, reject));
                    });
                    console.log('🟢 VITALS SAVED SUCCESSFULLY:', vitalsResponse);
                } catch (vitalsErr) {
                    console.error('🔴 VITALS SAVE FAILED:', vitalsErr);
                }
            } else {
                console.log('⚪ No vitals entered, skipping save');
            }

            console.log('Appointment added successfully', { variant: 'success' });
            resetForm();
            onClose();
        } catch (error) {
            toast.error(error.message || 'Failed to add appointment');
            console.error('Submission error:', error);
        }
    };

    return (
        <Formik
            enableReinitialize={false}
            initialValues={{
                patientId: 'Auto-generated',
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: null,
                gender: '',
                contactNo: '',
                patient: '',
                date: dayjs(),
                time: '',
                addnotes: '',
                consultingFees: 0,
                pincode: '',
                city: '',
                state: '',
                area: '',
                postalAddress: '',
                weight: '',
                height: '',
                pulseRate: '',
                spo2: '',
                respiratoryRate: '',
                temperature: '',
                scheduleType: 'appointment',
            }}
            validationSchema={validationSchema}
            onSubmit={(values, formikBag) => {
                console.log('Formik onSubmit triggered', values);
                handleSubmit(values, formikBag);
            }}

        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => {
                if (Object.keys(errors).length > 0) {
                    console.log('Formik Errors:', errors);
                }
                return (
                    <Form >
                        <FeeManager
                            consultingData={consultingData}
                            setConsultingFees={setConsultingFees}
                            isProfilesLoaded={isProfilesLoaded}
                            doctorId={urlDoctorId || getUserFromToken()}
                            clinicId={clinicId}
                            activeCase={activeCase}
                            setActiveCase={setActiveCase}
                        />
                        <FetchSlotsEffect clinicId={clinicId} token={token} />
                        <PincodeLookup customFields={customFields} setFieldValue={setFieldValue} setFilteredAreas={setFilteredAreas} setFilteredPincodes={setFilteredPincodes} setLookupSource={setLookupSource} />
                        <UniversalLocationSearch customFields={customFields} setFieldValue={setFieldValue} setFilteredAreas={setFilteredAreas} setFilteredPincodes={setFilteredPincodes} setLookupSource={setLookupSource} lookupSource={lookupSource} />
                        <HeaderPart>
                            Add Appointment
                            <CloseIcon
                                width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24}
                                onClick={onClose}
                                style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <MainComponent isExpanded={values.patient === 'New Patient'} >
                            <PatientSearch
                                setLastVisitDays={setLastVisitDays}
                                setConsultingFees={setConsultingFees}
                                doctorProfile={doctorProfile}
                                customFields={customFields}
                            />

                            {values.patient !== 'New Patient' && values.patient !== '' && (
                                <Box sx={{ mb: 2 }}>
                                    {activeCase ? (
                                        <Box sx={{
                                            p: 1.5,
                                            borderRadius: '12px',
                                            backgroundColor: 'rgba(76, 175, 80, 0.08)',
                                            border: '1px solid rgba(76, 175, 80, 0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#4CAF50' }} />
                                            <Typography variant="body2" sx={{ color: '#4CAF50', fontWeight: 600 }}>
                                                Active Case: {activeCase.caseNumber} (Valid till: {dayjs(activeCase.validityEndDate).format('DD-MM-YYYY')})
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <Box sx={{
                                            p: 1.5,
                                            borderRadius: '12px',
                                            backgroundColor: 'rgba(244, 67, 54, 0.08)',
                                            border: '1px solid rgba(244, 67, 54, 0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#F44336' }} />
                                            <Typography variant="body2" sx={{ color: '#F44336', fontWeight: 600 }}>
                                                No Active Case (Next visit will be New Case)
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            )}

                            {values.patient !== 'New Patient' && values.patient !== '' && (
                                <Component4 sx={{ mb: 2 }}>
                                    <Texts>Past Visit Days</Texts>
                                    <InputComponent
                                        name="pastVisitDays"
                                        readOnly={true}
                                        variant="outlined"
                                        fullWidth
                                        value={lastVisitDays !== null ? `${lastVisitDays} Days` : 'No past visits found'}
                                        sx={{
                                            backgroundColor: alpha(palette.gery.black, 0.04),
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                color: alpha(palette.gery.black, 0.6),
                                            },
                                        }}
                                    />
                                </Component4>
                            )}
                            {(values.patient === 'New Patient' || (values.patient && values.patient !== '')) && (
                                <>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                        {values.patient !== 'New Patient' && (
                                            <Component4>
                                                <Texts>Patient ID</Texts>
                                                <InputComponent
                                                    name="patientId"
                                                    readOnly={true}
                                                    variant="outlined"
                                                    fullWidth
                                                    value={values.patientId}
                                                    sx={{
                                                        backgroundColor: alpha(palette.gery.black, 0.04),
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '10px 0px',
                                                            borderRadius: '12px',
                                                            height: '52px',
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                            color: alpha(palette.gery.black, 0.6),
                                                        },
                                                    }}
                                                />
                                            </Component4>
                                        )}

                                        <Component2>
                                            <InnerComponent>
                                                <Texts>First Name</Texts>
                                                <InputComponent
                                                    name="firstName"
                                                    variant="outlined"
                                                    placeholder="Enter First Name"
                                                    fullWidth
                                                    value={values.firstName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched.firstName && Boolean(errors.firstName)}
                                                    helperText={touched.firstName && errors.firstName}
                                                    sx={{
                                                        backgroundColor: palette.gery.white,
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '10px 0px',
                                                            borderRadius: '12px',
                                                            height: '52px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                            <InnerComponent>
                                                <Texts>Middle Name</Texts>
                                                <InputComponent
                                                    name="middleName"
                                                    variant="outlined"
                                                    placeholder="Enter Middle Name"
                                                    fullWidth
                                                    value={values.middleName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    sx={{
                                                        backgroundColor: palette.gery.white,
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '10px 0px',
                                                            borderRadius: '12px',
                                                            height: '52px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                        </Component2>

                                        <Component2>
                                            <InnerComponent>
                                                <Texts>Last Name</Texts>
                                                <InputComponent
                                                    name="lastName"
                                                    variant="outlined"
                                                    placeholder="Enter Last Name"
                                                    fullWidth
                                                    value={values.lastName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={touched.lastName && Boolean(errors.lastName)}
                                                    helperText={touched.lastName && errors.lastName}
                                                    sx={{
                                                        backgroundColor: palette.gery.white,
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '10px 0px',
                                                            borderRadius: '12px',
                                                            height: '52px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                            <InnerComponent>
                                                <Texts>Phone Number</Texts>
                                                <InputComponent
                                                    name="contactNo"
                                                    variant="outlined"
                                                    placeholder="Enter Number"
                                                    fullWidth
                                                    value={values.contactNo}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                        setFieldValue('contactNo', val);
                                                    }}
                                                    onBlur={handleBlur}
                                                    inputProps={{
                                                        maxLength: 10,
                                                        pattern: "^[0-9]{10}$",
                                                    }}
                                                    error={touched.contactNo && Boolean(errors.contactNo)}
                                                    helperText={touched.contactNo && errors.contactNo}
                                                    sx={{
                                                        backgroundColor: palette.gery.white,
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '10px 0px',
                                                            borderRadius: '12px',
                                                            height: '52px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                        </Component2>

                                        <Component2>
                                            <InnerComponent>
                                                <Texts>Gender</Texts>
                                                <InputSelect
                                                    name="gender"
                                                    showNone={false}
                                                    options={genderData}
                                                    value={values.gender}
                                                    onChange={(value) => setFieldValue('gender', value)}
                                                    onBlur={handleBlur}
                                                    error={touched.gender && Boolean(errors.gender)}
                                                    helperText={touched.gender && errors.gender}
                                                    variant="outlined"
                                                    placeholder="Select"
                                                    sx={{

                                                        boxShadow: theme.shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>
                                            <InnerComponent>
                                                <Texts>Date of Birth</Texts>
                                                <DateTimePicker
                                                    name="dateOfBirth"
                                                    value={values.dateOfBirth ? dayjs(values.dateOfBirth) : null}
                                                    onChange={(val) => setFieldValue('dateOfBirth', val)}
                                                    onBlur={handleBlur}
                                                    error={touched.dateOfBirth && Boolean(errors.dateOfBirth)}
                                                    helperText={touched.dateOfBirth && errors.dateOfBirth}
                                                    type="date"
                                                    sx={{
                                                        height: "52px",
                                                        borderRadius: '12px',
                                                    }}
                                                />
                                            </InnerComponent>
                                        </Component2>

                                        <Component2>
                                            <InnerComponent>
                                                <Texts>Pincode</Texts>
                                                {filteredPincodes.length > 0 ? (
                                                    <InputSelect
                                                        name="pincode"
                                                        showNone={false}
                                                        options={filteredPincodes}
                                                        value={values.pincode || ''}
                                                        onChange={(val) => {
                                                            setFieldValue('pincode', val);
                                                            setLookupSource('pincode');
                                                            const pincodeField = customFields.find(f => f.label.toLowerCase().includes('pincode'));
                                                            if (pincodeField) setFieldValue(pincodeField.fieldName, val);
                                                            const selected = filteredPincodes.find(o => o.value === val);
                                                            if (selected) {
                                                                if (selected.city) {
                                                                    setFieldValue('city', selected.city);
                                                                    const cField = customFields.find(f => f.label.toLowerCase().includes('city'));
                                                                    if (cField) setFieldValue(cField.fieldName, selected.city);
                                                                }
                                                                if (selected.state) {
                                                                    setFieldValue('state', selected.state);
                                                                    const sField = customFields.find(f => f.label.toLowerCase().includes('state'));
                                                                    if (sField) setFieldValue(sField.fieldName, selected.state);
                                                                }
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        placeholder="Select Pincode"
                                                        sx={{
                                                            boxShadow: theme.shadows[1],
                                                            '& .MuiOutlinedInput-root': {
                                                                height: '52px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                borderRadius: '12px',
                                                            },
                                                        }}
                                                    />
                                                ) : (
                                                    <InputComponent
                                                        name="pincode"
                                                        variant="outlined"
                                                        placeholder="Enter Pincode"
                                                        fullWidth
                                                        value={values.pincode}
                                                        onChange={(e) => {
                                                            const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                            setFieldValue('pincode', val);
                                                            setLookupSource(null);
                                                            const pincodeField = customFields.find(f => f.label.toLowerCase().includes('pincode'));
                                                            if (pincodeField) setFieldValue(pincodeField.fieldName, val);
                                                        }}
                                                        onBlur={handleBlur}
                                                        inputProps={{ maxLength: 6 }}
                                                        sx={{
                                                            backgroundColor: palette.gery.white,
                                                            boxShadow: shadows[1],
                                                            '& .MuiOutlinedInput-root': {
                                                                padding: '10px 0px',
                                                                borderRadius: '12px',
                                                                height: '52px',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                            },
                                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                            },
                                                        }}
                                                    />
                                                )}
                                            </InnerComponent>
                                            <InnerComponent>
                                                {(() => {
                                                    const areaField = customFields.find(f => f.label.toLowerCase().includes('area'));
                                                    if (areaField) {
                                                        return (
                                                            <>
                                                                <Texts>{areaField.label}</Texts>
                                                                {filteredAreas.length > 0 ? (
                                                                    <InputSelect
                                                                        name={areaField.fieldName}
                                                                        showNone={false}
                                                                        options={filteredAreas}
                                                                        value={values[areaField.fieldName] || values.area || ''}
                                                                        onChange={(val) => {
                                                                            setFieldValue(areaField.fieldName, val);
                                                                            setFieldValue('area', val);
                                                                            // Senior logic: find the object to auto-fill linked fields
                                                                            const selected = filteredAreas.find(o => o.value === val);
                                                                            if (selected) {
                                                                                if (selected.pincode) {
                                                                                    setFieldValue('pincode', selected.pincode);
                                                                                    const pField = customFields.find(f => f.label.toLowerCase().includes('pincode'));
                                                                                    if (pField) setFieldValue(pField.fieldName, selected.pincode);
                                                                                }
                                                                                if (selected.city) {
                                                                                    setFieldValue('city', selected.city);
                                                                                    const cField = customFields.find(f => f.label.toLowerCase().includes('city'));
                                                                                    if (cField) setFieldValue(cField.fieldName, selected.city);
                                                                                }
                                                                                if (selected.state) {
                                                                                    setFieldValue('state', selected.state);
                                                                                    const sField = customFields.find(f => f.label.toLowerCase().includes('state'));
                                                                                    if (sField) setFieldValue(sField.fieldName, selected.state);
                                                                                }
                                                                                setLookupSource('selection');
                                                                            }
                                                                        }}
                                                                        variant="outlined"
                                                                        placeholder="Select"
                                                                        sx={{
                                                                            boxShadow: theme.shadows[1],
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '52px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                borderRadius: '12px',
                                                                            },
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <InputComponent
                                                                        name={areaField.fieldName}
                                                                        variant="outlined"
                                                                        placeholder={`Enter ${areaField.label}`}
                                                                        fullWidth
                                                                        value={values[areaField.fieldName] || values.area || ''}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            setFieldValue('area', e.target.value);
                                                                            setLookupSource(null);
                                                                        }}
                                                                        sx={{
                                                                            backgroundColor: palette.gery.white,
                                                                            boxShadow: shadows[1],
                                                                            '& .MuiOutlinedInput-root': {
                                                                                padding: '10px 0px',
                                                                                borderRadius: '12px',
                                                                                height: '52px',
                                                                            },
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            </>
                                                        );
                                                    }
                                                    return <Texts>&nbsp;</Texts>;
                                                })()}
                                            </InnerComponent>
                                        </Component2>

                                        <Component2>
                                            <InnerComponent>
                                                {(() => {
                                                    const cityField = customFields.find(f => f.label.toLowerCase().includes('city'));
                                                    if (cityField) {
                                                        return (
                                                            <>
                                                                <Texts>{cityField.label}</Texts>
                                                                <InputComponent
                                                                    name={cityField.fieldName}
                                                                    variant="outlined"
                                                                    placeholder={`Enter ${cityField.label} (e.g. Ahmedabad)`}
                                                                    fullWidth
                                                                    value={values[cityField.fieldName] || values.city || ''}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        setFieldValue('city', e.target.value);
                                                                        // Reset source so location search triggers
                                                                        setLookupSource(null);
                                                                    }}
                                                                    sx={{
                                                                        backgroundColor: palette.gery.white,
                                                                        boxShadow: shadows[1],
                                                                        '& .MuiOutlinedInput-root': {
                                                                            padding: '10px 0px',
                                                                            borderRadius: '12px',
                                                                            height: '52px',
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                                        },
                                                                    }}
                                                                />
                                                            </>
                                                        );
                                                    }
                                                    return <Texts>&nbsp;</Texts>;
                                                })()}
                                            </InnerComponent>
                                            <InnerComponent>
                                                {(() => {
                                                    const stateField = customFields.find(f => f.label.toLowerCase().includes('state'));
                                                    if (stateField) {
                                                        return (
                                                            <>
                                                                <Texts>{stateField.label}</Texts>
                                                                <InputComponent
                                                                    name={stateField.fieldName}
                                                                    variant="outlined"
                                                                    placeholder={`Enter ${stateField.label}`}
                                                                    fullWidth
                                                                    value={values[stateField.fieldName] || values.state || ''}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        setFieldValue('state', e.target.value);
                                                                    }}
                                                                    sx={{
                                                                        backgroundColor: palette.gery.white,
                                                                        boxShadow: shadows[1],
                                                                        '& .MuiOutlinedInput-root': {
                                                                            padding: '10px 0px',
                                                                            borderRadius: '12px',
                                                                            height: '52px',
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                                        },
                                                                    }}
                                                                />
                                                            </>
                                                        );
                                                    }
                                                    return <Texts>&nbsp;</Texts>;
                                                })()}
                                            </InnerComponent>
                                        </Component2>

                                        {customFields.filter(f => f.label.toLowerCase().includes('postal address')).map(field => (
                                            <Component4 key={field.fieldName}>
                                                <Texts>{field.label}</Texts>
                                                <InputComponent
                                                    name={field.fieldName}
                                                    variant="outlined"
                                                    placeholder={`Enter ${field.label}`}
                                                    fullWidth
                                                    multiline
                                                    rows={3}
                                                    value={values[field.fieldName] || values.postalAddress || ''}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setFieldValue('postalAddress', e.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    error={touched[field.fieldName] && Boolean(errors[field.fieldName])}
                                                    helperText={touched[field.fieldName] && errors[field.fieldName]}
                                                    sx={{
                                                        backgroundColor: palette.gery.white,
                                                        boxShadow: shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '12px 16px',
                                                            borderRadius: '12px',
                                                            minHeight: '100px',
                                                            alignItems: 'flex-start',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                        },
                                                        "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                            ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                        },
                                                    }}
                                                />
                                            </Component4>
                                        ))}

                                        {(() => {
                                            const standardLabels = ['pincode', 'area', 'city', 'state', 'postal address', 'weight', 'height', 'pulse', 'spo2', 'respiratory', 'temp'];
                                            const otherFields = customFields.filter(f =>
                                                !standardLabels.some(label => f.label.toLowerCase().includes(label))
                                            );
                                            const rows = [];
                                            for (let i = 0; i < otherFields.length; i += 2) {
                                                rows.push(otherFields.slice(i, i + 2));
                                            }
                                            return rows.map((row, rowIndex) => (
                                                <Component2 key={rowIndex}>
                                                    {row.map(field => (
                                                        <InnerComponent key={field.fieldName}>
                                                            <Texts>{field.label}</Texts>
                                                            <InputComponent
                                                                name={field.fieldName}
                                                                variant="outlined"
                                                                placeholder={`Enter ${field.label}`}
                                                                fullWidth
                                                                type={field.type === 'number' ? 'number' : 'text'}
                                                                value={values[field.fieldName] || ''}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={touched[field.fieldName] && Boolean(errors[field.fieldName])}
                                                                helperText={touched[field.fieldName] && errors[field.fieldName]}
                                                                sx={{
                                                                    backgroundColor: palette.gery.white,
                                                                    boxShadow: shadows[1],
                                                                    '& .MuiOutlinedInput-root': {
                                                                        padding: '10px 0px',
                                                                        borderRadius: '12px',
                                                                        height: '52px',
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                                                    },
                                                                    "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                                        ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                                                    },
                                                                }}
                                                            />
                                                        </InnerComponent>
                                                    ))}
                                                    {row.length === 1 && <InnerComponent />}
                                                </Component2>
                                            ));
                                        })()}
                                    </Box>
                                </>

                            )}


                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                {isAcceptingTokens && (
                                    <Component4>
                                        <Texts>Schedule Type</Texts>
                                        <InputSelect
                                            name="scheduleType"
                                            variant="outlined"
                                            showNone={false}
                                            value={values.scheduleType}
                                            onChange={(val) => setFieldValue('scheduleType', val)}
                                            onBlur={handleBlur}
                                            options={[
                                                { label: 'Appointment', value: 'appointment' },
                                                { label: 'Token', value: 'token' }
                                            ]}
                                            sx={{ height: "52px", borderRadius: '12px' }}
                                        />
                                    </Component4>
                                )}

                                <Component2>
                                    <InnerComponent>
                                        <Texts>Appointment Date</Texts>
                                        <DateTimePicker
                                            name="date"
                                            value={values.date}
                                            onChange={(value) => setFieldValue('date', value)}
                                            onBlur={handleBlur}
                                            error={touched.date && Boolean(errors.date)}
                                            helperText={touched.date && errors.date}
                                            minDate={dayjs().startOf('day')}
                                            type="date"
                                            sx={{
                                                height: "52px",
                                                borderRadius: '12px',
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Appointment Timeslot</Texts>
                                        <InputSelect
                                            name="time"
                                            variant="outlined"
                                            showNone={false}
                                            value={values.time}
                                            onChange={(val) => setFieldValue('time', val)}
                                            onBlur={handleBlur}
                                            error={touched.time && Boolean(errors.time)}
                                            helperText={touched.time && errors.time}
                                            fullWidth
                                            placeholder="Select Timeslot"
                                            options={(function () {
                                                const is24 = (Intl.DateTimeFormat(undefined).resolvedOptions().hourCycle || '').includes('24');
                                                const d = dayjs(values.date).isValid() ? dayjs(values.date) : dayjs(values.date, 'DD/MM/YYYY');
                                                const now = dayjs();
                                                const isToday = d.format('YYYY-MM-DD') === now.format('YYYY-MM-DD');
                                                const selectedDay = d.format('dddd').toLowerCase();

                                                const minPriorTime = Number(clinicProfile?.clinicSetting?.minimumPriorBookingTime || 0);
                                                const threshold = now.add(minPriorTime, 'minutes');

                                                console.log('[GraceTime Debug] Date:', d.format('YYYY-MM-DD'), 'isToday:', isToday);
                                                console.log('[GraceTime Debug] minPriorTime:', minPriorTime);
                                                console.log('[GraceTime Debug] Threshold:', threshold.format('HH:mm'));

                                                const dayTimings = (doctorTimings?.timings || []).filter(t => (t.day?.value || t.day)?.toLowerCase() === selectedDay);
                                                const clinicTimings = (clinicProfile?.clinicTiming || []).filter(t => (t.day?.value || t.day)?.toLowerCase() === selectedDay);

                                                let currentGap = gap || 15;

                                                if (availableSlots && availableSlots.length > 0) {
                                                    let filteredSlots = availableSlots;
                                                    if (isToday) {
                                                        console.log(`[GraceTime Debug] Filtering today's slots. Threshold: ${threshold.format('hh:mm A')}`);
                                                        filteredSlots = availableSlots.filter(slot => {
                                                            const slotTime = dayjs(`${d.format('YYYY-MM-DD')} ${slot}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A']);
                                                            const isAfterThreshold = slotTime.isAfter(threshold);
                                                            // console.log(`[GraceTime Debug] Slot: ${slot} -> isAfterThreshold: ${isAfterThreshold}`);
                                                            return isAfterThreshold;
                                                        });
                                                    }
                                                    return filteredSlots.map(slot => ({
                                                        label: dayjs(`${d.format('YYYY-MM-DD')} ${slot}`, ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm A']).format('hh:mm A'),
                                                        value: slot
                                                    }));
                                                }

                                                if (currentGap <= 0) currentGap = 15;

                                                const slots = [];
                                                const seenSlots = new Set();

                                                const ranges = isSingleDoctor
                                                    ? (clinicTimings.length > 0 ? clinicTimings : [{ startTime: '08:00 AM', endTime: '09:00 PM' }])
                                                    : (dayTimings.length > 0 ? dayTimings : [{ startTime: '08:00 AM', endTime: '09:00 PM' }]);

                                                ranges.forEach(timing => {
                                                    const startTimeStr = timing.startTime;
                                                    const endTimeStr = timing.endTime;

                                                    const start = dayjs(startTimeStr).isValid() ? dayjs(startTimeStr) : dayjs(startTimeStr, ['h:mm A', 'hh:mm A', 'HH:mm', 'hA', 'ha']);
                                                    const end = dayjs(endTimeStr).isValid() ? dayjs(endTimeStr) : dayjs(endTimeStr, ['h:mm A', 'hh:mm A', 'HH:mm', 'hA', 'ha']);

                                                    if (!start.isValid() || !end.isValid()) return;

                                                    let startHour = start.hour();
                                                    let startMinute = start.minute();
                                                    let endHour = end.hour();
                                                    let endMinute = end.minute();

                                                    let current = d.startOf('day').hour(startHour).minute(startMinute);

                                                    if (isToday) {
                                                        if (threshold.isAfter(current)) {
                                                            current = threshold;
                                                        }
                                                    }

                                                    const minutes = current.minute();
                                                    const roundedMinutes = Math.ceil(minutes / currentGap) * currentGap;
                                                    current = current.minute(roundedMinutes).second(0);

                                                    const endOfRange = d.startOf('day').hour(endHour).minute(endMinute);

                                                    for (let t = current; t.isBefore(endOfRange); t = t.add(currentGap, 'minutes')) {
                                                        const val = t.format('HH:mm');
                                                        if (!seenSlots.has(val)) {
                                                            const label = is24 ? t.format('HH:mm') : t.format('hh:mm A');
                                                            slots.push({ label, value: val });
                                                            seenSlots.add(val);
                                                        }
                                                    }
                                                });

                                                slots.sort((a, b) => a.value.localeCompare(b.value));

                                                return slots;
                                            })()}
                                            sx={{ height: "52px", borderRadius: '12px' }}
                                        />
                                    </InnerComponent>
                                </Component2>

                                <Component4>
                                    <Texts>Symptoms</Texts>
                                    <InputComponent
                                        name="addnotes"
                                        variant="outlined"
                                        placeholder="Enter Symptoms"
                                        fullWidth
                                        multiline
                                        value={values.addnotes}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.addnotes && Boolean(errors.addnotes)}
                                        helperText={touched.addnotes && errors.addnotes}
                                        rows={4}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '16px 18px',
                                                borderRadius: '12px',
                                                height: '120px',
                                                alignItems: 'flex-start',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </Component4>

                                <Component2>
                                    <InnerComponent>
                                        <Texts>Weight (kg)</Texts>
                                        <InputComponent
                                            name="weight"
                                            variant="outlined"
                                            placeholder="kg"
                                            fullWidth
                                            value={values.weight}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Height (cm)</Texts>
                                        <InputComponent
                                            name="height"
                                            variant="outlined"
                                            placeholder="cm"
                                            fullWidth
                                            value={values.height}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>

                                <Component2>
                                    <InnerComponent>
                                        <Texts>Pulse Rate (bpm)</Texts>
                                        <InputComponent
                                            name="pulseRate"
                                            variant="outlined"
                                            placeholder="bpm"
                                            fullWidth
                                            value={values.pulseRate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>SpO2 (%)</Texts>
                                        <InputComponent
                                            name="spo2"
                                            variant="outlined"
                                            placeholder="%"
                                            fullWidth
                                            value={values.spo2}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>

                                <Component2>
                                    <InnerComponent>
                                        <Texts>Resp. Rate (bpm)</Texts>
                                        <InputComponent
                                            name="respiratoryRate"
                                            variant="outlined"
                                            placeholder="bpm"
                                            fullWidth
                                            value={values.respiratoryRate}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                    <InnerComponent>
                                        <Texts>Temp (°F)</Texts>
                                        <InputComponent
                                            name="temperature"
                                            variant="outlined"
                                            placeholder="°F"
                                            fullWidth
                                            value={values.temperature}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            sx={{
                                                backgroundColor: palette.gery.white,
                                                boxShadow: shadows[1],
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                    height: '52px',
                                                },
                                            }}
                                        />
                                    </InnerComponent>
                                </Component2>

                                <Component4>
                                    <Texts>Consulting Fees</Texts>
                                    <InputComponent
                                        name="consultingFees"
                                        variant="outlined"
                                        fullWidth
                                        readOnly
                                        value={values.consultingFees}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                padding: '10px 0px',
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </Component4>
                            </Box>
                        </MainComponent>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon
                                    width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24}
                                    sx={{ color: theme.palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon
                                    width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24}
                                    sx={{ color: theme.palette.primary.main }} />}
                                disabled={isSubmitting}
                                onClick={() => {
                                    if (Object.keys(errors).length > 0) {
                                        console.error('Formik validation errors:', errors);
                                        const firstError = Object.values(errors)[0];
                                        toast.error(firstError);
                                    }
                                }}
                            >Save</SaveButton>
                        </FooterPart>
                    </Form>
                );
            }}
        </Formik>
    )
}

export default AddAppointment;